"use client";
/** Discard the router cache and all tenant-local client state at an identity boundary. */
export function navigateFresh(path: string) {
  window.location.assign(new URL(path, window.location.origin).href);
}
